import React from "react";
import "./products.scss";
import { withRouter } from "react-router";
import { Row } from "reactstrap";
import PlanCard from "../../common/cards/PlanCard";

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlan: "family",
      device: "web",

      singlePlan: {
        title: "Single",
        icon: require("../../../assets/images/landing/single-plan-logo.png"),
        subTitle: "3-in-1 plan for your health, life and household insurance",
        rate: "880",
        plan: "single",
        benifits: "Single Plan Benefits",
        included: [
          "Health Insurance of ₹5 Lakhs",
          "Life Insurance of ₹50 Lakhs",
          "Household Insurance of ₹1.25 Lakhs"
        ]
      },
      familyPlan: {
        title: "Family",
        icon: require("../../../assets/images/landing/family-plan-logo.png"),
        subTitle:
          "3-in-1 plan for your life, your family’s health and household",
        rate: "1046",
        plan: "family",
        benifits: "Family Plan Benefits",
        included: [
          "Health Insurance of ₹5 Lakhs (For each family member)",
          "Life Insurance of ₹50 Lakhs",
          "Household Insurance of ₹1.25 Lakhs",
          "Covers up to 4 family members"
        ]
      }
    };
  }
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  navigateToProduct(plan) {
    this.props.history.push("/product/" + plan);
  }
  selectPlan(plan) {
    // if (this.state.selectedPlan === plan) {
    //   this.state.device === "web" && this.navigateToProduct();
    //   return;
    // }
    this.setState({
      selectedPlan: plan
    });
  }
  render() {
    return (
      <div id={"section1"} className="products-container">
        <h3 className="title opacity-90 text-center mb-mobile-24">
          Best of three, rolled in one
        </h3>
        <h3 className="title-2 text-center font-weight-bold mb-24">
          Health Insurance + Life Insurance + Household Insurance
        </h3>
        <h3 className="sub-title mb-35 mb-mobile-35">
          Thrice the coverage, twice the convenience, zero extra paperwork. Yay!
        </h3>
        <div className="box-container">
          <Row className="m-0 p-0 d-flex align-items-center">
            <PlanCard
              data={this.state.singlePlan}
              active={this.state.selectedPlan === this.state.singlePlan.plan}
              onClickCard={plan => {
                this.selectPlan(plan);
              }}
              onClickButton={data => {
                this.navigateToProduct("single");
              }}
            />
            <PlanCard
              data={this.state.familyPlan}
              active={this.state.selectedPlan === this.state.familyPlan.plan}
              onClickCard={plan => {
                this.selectPlan(plan);
              }}
              onClickButton={data => {
                this.navigateToProduct("family");
              }}
            />
          </Row>
          {/* <div className="text-center btn-container mobile-only">
            <InnerShadowButton
              clicked={e => {
                this.navigateToProduct();
              }}
              title="See More Benefits"
            />
          </div> */}
        </div>
      </div>
    );
  }
}

export default withRouter(Products);
